
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 5h12v2h-2v20h-2V7h-2v20h-2V17h-4c-3.302 0-6-2.698-6-6s2.698-6 6-6zm0 2c-2.22 0-4 1.78-4 4s1.78 4 4 4h4V7h-4z"}})])
          )
        }
      }
    